import React from 'react';
import { RouteProps } from 'react-router-dom';
import DefaultAside from '../pages/_layout/_asides/DefaultAside';

// Aside is only rendered when user is logged in (see AsideRoutes.tsx).
const asides: RouteProps[] = [{ path: '*', element: <DefaultAside /> }];

export default asides;
